import {HttpCrudDataSource} from '../../core/data-source/http-crud.data-source';
import {fromJson} from '../../core/data-source/json.mapper';
import {httpService, IHttpRequestOptions} from '../../core/services/http.service';
import {DictionaryRecord} from '../../records/dictionary.record';

export class VehicleRequirementCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/types';

    async getIncompatibaleVehRequirements(params: IHttpRequestOptions): Promise<DictionaryRecord[]> {
        return httpService
            .get(this.apiPath + '/compactList', params)
            .then((response: any) => response.data.rows.map((v: any) => fromJson(DictionaryRecord, v)));
    }
}
